module.exports = __webpack_public_path__ + "static/media/logo-wildling.3ddca84b.svg";